<template>
    <div>
        <search-banner
                placeholder="Search repair kits"
                :searchValue.sync="searchValue"
                sticky>
        </search-banner>

        <div class="container">

            <loading-state
                    v-if="loading"
                    title="Loading repair kits to pick">
            </loading-state>

            <template v-if="repairKitsToBePicked.length > 0">
                <!-- Kits -->
                <div class="row mb-2">
                    <div class="col-md-12 d-flex">
                        <label class="mt-2">Repair kits to pick ({{ filteredRepairKitsToBePicked.length }})</label>
                        <div class="ml-auto mr-2 mt-3 cursor-pointer" v-if="!syncing" @click="syncList()">
                            <icon-refresh size="sm" class="icon-all-white icon-chunky"></icon-refresh>
                        </div>
                        <div class="ml-auto mr-2 mt-3 cursor-not-allowed" v-if="syncing">
                            <icon-refresh size="sm" class="icon-all-white icon-chunky fa-spin"></icon-refresh>
                        </div>
                    </div>
                </div>
                <div class="card-grid vertical">
                    <div v-for="repairKit in filteredRepairKitsToBePicked" :key="repairKit.id">
                        <router-link
                                :to="{name: 'repairKitPicking.repairKit', params: {repairKitId:repairKit.id}}"
                                class="card card-body card-link py-3 justify-content-between flex-row align-items-center">
                            <div>
                                Repair kit: <strong>{{repairKit.id}}</strong>
                                <p class="mb-0 text-xs" v-if="repairKit.in_house_technician">
                                    <i class="fal fa-info-circle"></i> In-house repair
                                </p>
                            </div>
                            <span v-if="repairKit.currently_picking" class="badge badge-red badge-sm">Picking</span>
                            <div>Zone {{repairKit.picking_zone}}</div>
                        </router-link>
                    </div>
                </div>
            </template>

            <!-- Empty State -->
            <empty-state
                v-if="repairKitsToBePicked.length < 1"
                emptyIcon
                icon="box"
                title="There are no repair kits to pick">
            </empty-state>

            <!-- No Search Results -->
            <empty-state
                    v-if="filteredRepairKitsToBePicked.length < 1 && repairKitsToBePicked.length > 0"
                    emptyIcon
                    faIcon="search"
                    title="No repair kits match that search">
            </empty-state>

        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        data() {
            return {
                loading: true,
                searchValue: "",
                syncing: false
            }
        },

        props:['kitPicked'],

        mounted() {
            this.loadTodaysRepairKits()
                .then(() => {
                    this.loading = false;
            });
            if (this.kitPicked) {
                this.displayToast({text: 'Kit has been picked', type: 'success'});
            }
        },

        computed: {
            ...mapGetters([
                'repairKits',
                'repairKitsToBePicked'
            ]),

            /** Return repair kits, including search results */
            filteredRepairKitsToBePicked() {
                let filtered = this.repairKitsToBePicked;

                if (this.searchValue) {
                    let searchValue = this.searchValue.toLowerCase()

                    filtered = filtered.filter (
                        r => r.id.includes(searchValue) || r.picking_zone.toLowerCase().includes(searchValue)
                    )
                }

                return filtered.sort(function(a, b) {
                    if (a.picking_zone < b.picking_zone) {
                        return -1;
                    }
                    if (a.picking_zone > b.picking_zone) {
                        return 1;
                    }
                    return 0;
                });
            }
        },

        methods: {
            ...mapActions([
                'displayToast',
                'loadTodaysRepairKits',
                'syncKitList'
            ]),

            syncList() {
                this.syncing = true;
                this.syncKitList();

                let self = this;
                setTimeout(() =>{
                    self.syncing = false
                }, 4000);
            }
        }
    }
</script>

<style scoped>

</style>